import { render, staticRenderFns } from "./InternationalStorage.vue?vue&type=template&id=650df462&scoped=true"
import script from "./InternationalStorage.vue?vue&type=script&lang=js"
export * from "./InternationalStorage.vue?vue&type=script&lang=js"
import style0 from "./InternationalStorage.vue?vue&type=style&index=0&id=650df462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650df462",
  null
  
)

export default component.exports